/**
 * Route for `cap-types-approved-payout-revenue-clicks-conversion-pending`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapTypesApprovedPayoutRevenueClicksConversionPendingPage } from "../features/cap-types-approved-payout-revenue-clicks-conversion-pending/CapTypesApprovedPayoutRevenueClicksConversionPendingPage";

export const capTypesApprovedPayoutRevenueClicksConversionPendingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cap-types-approved-payout-revenue-clicks-conversion-pending",
	component: CapTypesApprovedPayoutRevenueClicksConversionPendingPage,
});

export default capTypesApprovedPayoutRevenueClicksConversionPendingRoute;
